export enum AddressFieldHelperText {
    Property = "Please enter a valid property",
    BusinessName = "Please enter a valid business name",
    City = "Please enter a valid city",
    Country = "Please enter a valid country",
    PropertyNumber = "Please enter a valid flat number",
    Locality = "Please enter a valid locality",
    Postcode = "Please enter a valid postcode",
    Street = "Please enter a valid street",
}

export enum ContactFieldHelperText {
    Email = "Please enter a valid email",
    FirstName = "Please enter a valid first name",
    Landline = "Please enter a valid landline number",
    LastName = "Please enter a valid last name",
    Mobile = "Please enter a valid mobile number",
    Title = "Please enter a valid title",
    Relationship = "Please enter a valid relationship",
}

export enum BoilerFieldDateHelperText {
    BoilerInstallationDate = "Please select a valid installation date",
    BoilerLastServicedDate = "Please select a valid last serviced date",
    BoilerManufacturers = "Please select a valid boiler manufacturer",
    BoilerModel = "Please enter a valid boiler model",
    HeatingTypes = "Please select a valid heating type",
}

export enum PropertyFieldHelperText {
    Bathrooms = "Please set a valid number of bathrooms",
    Bedrooms = "Please set a valid number of bedrooms",
    BuildingTypes = "Please select a valid building type",
    ExternalDoors = "Please set a valid number of doors",
    GasAppliances = "Please set a valid number of gas appliances",
    Radiators = "Please set a valid number of radiators",
    GasSafetyDueDate = "Please select a valid gas safety due date",
}

export enum PlanOptionsFieldHelperText {
    BillingFrequency = "Please select a payment frequency",
    Duration = "Please select a payment duration",
    Excess = "Please select an excess",
    PlanType = "Please select a valid plan type",
}

export enum OfferFieldHelperText {
    OfferType = "Please select a valid offer type",
    OfferReason = "Please select a valid offer reason",
    PromoCode = "Please enter a valid promo code",
}

export enum PaymentTypesHelperText {
    PaymentMethod = "Please select a valid payment method",
    Requisition = "Please provide email address in contact details in order to send payment requisition",
    Registration = "Please provide valid registration number",
}

export enum PaymentBankDetailsHelperText {
    AccountCode = "Please enter a valid account code",
    SortCode = "Please enter a valid sort code",
    BankName = "Bank branch name is not verified. Please check and confirm",
}